<template>
  <div
    v-if="displayPrice !== undefined"
    class="price-tag"
    :data-is-rebooking="isRebookingActual"
    :data-original-booking-price="
      myTravelStore.originalBookingPrice?.amount || 0
    "
  >
    <span class="body-large">
      {{ isRebookingActual ? 'Å betale' : 'Totalt' }}
    </span>
    {{ displayPrice }}
  </div>
</template>

<script setup lang="ts">
  import { computed } from 'vue'
  import { useMyTravelStore } from '@/stores/myTravelStore'

  const props = defineProps<{
    isRebooking: boolean
  }>()

  const myTravelStore = useMyTravelStore()

  const formatPrice = (price: number): string => {
    if (typeof price !== 'number' || isNaN(price)) return '0,-'
    if (price === 0) return '0,-'
    return `${Math.floor(price).toFixed(0)},-`
  }

  const isRebookingActual = computed(() => {
    if (props.isRebooking) return true

    const urlParams = new URLSearchParams(window.location.search)
    return (
      urlParams.get('isRebooking') === 'true' ||
      !!myTravelStore.originalBookingPrice?.amount
    )
  })

  const displayPrice = computed(() => {
    const outboundEquipmentPrice = myTravelStore.outboundEquipmentPriceInKroner
    const inboundEquipmentPrice = myTravelStore.inboundEquipmentPriceInKroner
    const outboundSeatPrice = myTravelStore.outboundSeatPriceInKroner
    const inboundSeatPrice = myTravelStore.inboundSeatPriceInKroner

    if (
      myTravelStore.totalPriceToBePaid?.amount !== undefined &&
      !isNaN(myTravelStore.totalPriceToBePaid.amount)
    ) {
      let amount = myTravelStore.totalPriceToBePaid.amount
      if (
        'inOre' in myTravelStore.totalPriceToBePaid &&
        myTravelStore.totalPriceToBePaid.inOre
      ) {
        amount = amount / 100
      }

      console.log('  - Using totalPriceToBePaid:', amount)
      return formatPrice(amount)
    }

    const ticketPriceValue = myTravelStore.totalPrice?.amount
    const totalEquipmentPrice = myTravelStore.totalEquipmentPriceInKroner

    const validTicketPrice = isNaN(ticketPriceValue) ? 0 : ticketPriceValue ?? 0
    const totalSeatPrice = myTravelStore.totalSeatPriceInKroner
    const equipmentPrice = myTravelStore.totalEquipmentPriceInKroner || 0
    const discountAmount = myTravelStore.totalDiscountsAmount || 0

    const validSeatPrice = isNaN(totalSeatPrice) ? 0 : totalSeatPrice
    const validEquipmentPrice = isNaN(equipmentPrice) ? 0 : equipmentPrice

    const baseTotal = validTicketPrice + validSeatPrice + validEquipmentPrice
    const totalAfterDiscounts = baseTotal - discountAmount

    return formatPrice(totalAfterDiscounts)
  })
</script>

<style lang="scss" scoped>
  .price-tag {
    @include title-medium;
    display: flex;
    align-items: flex-end;
    justify-content: center;
    align-content: center;
    color: #333;
    line-height: 1;

    span {
      margin-right: 0.3rem;
      line-height: 1;
    }
  }
</style>
